/*
  Shopify Inbox chat, on our terms.

  The <shopify-chat> element keeps its launcher button inside a shadow root, so page CSS
  can't touch it — we inject a style into that root instead, to lift the button clear of
  the sticky buy bar (or to hide it, if the header setting says so). Any link marked
  [data-er-chat] opens the panel; those are real links to the contact page, so they stay
  useful if the chat app is removed or blocked.
*/
(function () {
  const TAG = 'shopify-chat';

  // The launcher sits in a shadow root nested inside the element's own, so collect
  // every root rather than assuming where it lives.
  function shadowRoots(node, found = []) {
    if (node.shadowRoot) {
      found.push(node.shadowRoot);
      node.shadowRoot.querySelectorAll('*').forEach((child) => shadowRoots(child, found));
    }
    return found;
  }

  function styleLauncher(el) {
    if (!el) return;
    // Hiding only. The lift is page CSS on ::part(activator), so the two can't stack.
    const hide = window.erHideChatLauncher === true;
    const css = hide
      ? '.activator, .activator-nudge, ::part(activator) { display: none !important; }'
      : '';

    shadowRoots(el).forEach((root) => {
      if (!root.querySelector('.activator, .activator-nudge')) return;
      let style = root.querySelector('style[data-er-chat]');
      if (style && style.textContent === css) return;
      if (!style) {
        style = document.createElement('style');
        style.setAttribute('data-er-chat', '');
        root.appendChild(style);
      }
      style.textContent = css;
    });
  }

  function chat() {
    return document.querySelector(TAG);
  }

  function apply() {
    document.documentElement.toggleAttribute('data-er-hide-chat', window.erHideChatLauncher === true);
    styleLauncher(chat());
  }

  // The app embed loads late, and re-renders when the panel opens or closes.
  apply();
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', apply);

  // Shopify Inbox exposes show()/close(); older builds used a boolean `open` property.
  window.erOpenChat = function () {
    const el = chat();
    if (!el) return false;
    try {
      if (typeof el.show === 'function') {
        el.show();
        return true;
      }
      if ('open' in el) {
        el.open = true;
        return true;
      }
    } catch (e) {
      /* fall through to the link's href */
    }
    return false;
  };

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-er-chat]');
    if (link && window.erOpenChat()) e.preventDefault();
  });
})();
